"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import  Zeusdetailscontent from '../components/Zeusdetailscontent';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import LightningProductsSubMenu from '../components/LightningProductsSubMenu';

import zeusban from '../images/zeusdetails/zeus_page_banner.jpg';
import zeusban_360 from '../images/zeusdetails/zeus_page_banner_360.jpg';
import zeusban_tab from '../images/zeusdetails/zeus_page_banner_tab.jpg';
import zeusban2x from  '../images/zeusdetails/zeus_page_banner.jpg';

// import ProducthomeBanner from '../components/ProducthomeBanner';
// import ban1x from '../images/producthome/product-home-banner.jpg';
// import ban2x from '../images/producthome/product-home-banner@2x.jpg';
const ZeusPage = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    //setIpageValue(item);
    //console.log("set new ipaf vale "+item);
    
  };
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Ashlok Zeus SLPR ESE lightning arrester — NFC 17-102" apostropheBefore=""  apostropheAfter="" ban1x={zeusban} ban2x={zeusban2x} ban360={zeusban_360} bantab={zeusban_tab}/>
            <ProductsubMenu/>
            <LightningProductsSubMenu onImageClick={handleItemClick}/>
          
          <Zeusdetailscontent/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default ZeusPage
 
